

<template>
	<div class="button" :class="[{current:current}, align, navClass, `cnt-${index}`]" :style="style">
		<a @click="onClick" class="link mb-5" :class="{disabled:disabled}">
			<div class="hover-wrap">
				<h5 class="px-5 py-2">
					<slot></slot>
				</h5>
			</div>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';

export default {
	props: ['disabled', 'link', 'y', 'x', 'align', 'node', 'navClass', 'index'],
	data: () => {
		return {
		}
	},
	computed: {
		current() {
			return this.$route.name == this.link
		},
		style: function () 	{
			return {
				top: this.y + `%`,
				left: this.x + `%`
			}
		}
	},

	mounted() {
		//console.log( this.$route );
	},

	methods: {
		onClick() {
			EventBus.$emit('nav-clicked', {
				link: this.link,
				node: this.node,
			});
		}
	}

}
</script>

<style scoped lang="scss">
		
	.button {
		position: absolute;
		white-space: nowrap;
		perspective: 5000px;
		perspective-origin: 0 -2500px;

		.link {
			position: absolute;
			left: 0;
			top: 0;
			display: inline-block;
			position: relative;
			transform: rotateY(45deg) scaleX(1.2) translate(-100%, 0);
			transform-origin: top left;
			transition: 0.2s all;
			overflow: hidden;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			user-select: none;
			cursor: pointer;
		}

		&.left {
			perspective-origin: 0 -2500px;
			.link {
				transform: rotateY(-45deg) scaleX(1.2) translate(0, 0);
			}
		}
		&.center .link {
			transform: rotateY(45deg) scaleX(1.2) translate(-50%, 0);
		}
		h5 {
			color: #009897;
			line-height: 1;
			font-family: $font-condensed;
			font-size: 3vh;
			font-weight: 600;
			letter-spacing: 0.02em;
			text-transform: uppercase;
			background-color: #5abfbe;
			margin: 0;
			padding: 0;
			opacity: 0.1;
			animation: 1s slide-in-right forwards;
			transform: translateX(-100%);
		}
		&.right h5 {
			animation: 1s slide-in-left forwards;
		}
		&.center h5 {
			animation: 1s slide-up forwards;
		}
	}

	@for $i from 0 through 10 {
		.cnt-#{$i}.button h5 {
			animation-delay: #{$i*0.15 + 0.4}s;
		}
	}

	.pflege { 
		&.button, .button {
			h5 {
				background-color: #80cae3;
				color: #1b9fcc;			
			}
		}
	}

	.hover-wrap {
		transition: 0.2s all;
	}

	.button:hover .hover-wrap {
		transform: translateX(-5%);
	}

	.button.right:hover .hover-wrap {
		transform: translateX(5%);
	}

	.button.center:hover {
		.hover-wrap {
			transform: translateX(0);
		}
		.link {
			transform: rotateY(45deg) scaleX(1.2) translate(-50%, -10%);
		}
	}

	.map-leave {
		.button .hover-wrap {
			transform: translateX(-100%);
		}
		.button.right .hover-wrap {
			transform: translateX(100%);
		}
		.button.center .hover-wrap {
			transform: translateY(100%);
		}
	}
	
	@keyframes slide-up {
		0% {
			transform: translateY(100%);
			opacity: 1;
		}
		100% {
			transform: translateY(0);
			opacity: 1;
		}
	}
	@keyframes slide-in-left {
		0% {
			transform: translateX(100%);
			opacity: 1;
		}
		100% {
			transform: translateX(0);
			opacity: 1;
		}
	}
	@keyframes slide-in-right {
		0% {
			transform: translateX(-100%);
			opacity: 1;
		}
		100% {
			transform: translateX(0);
			opacity: 1;
		}
	}

</style>
